import { Badge, Button, Card, Container, Divider, Grid, Group, NumberInput, Select, SimpleGrid, Skeleton, Stack, Table, ThemeIcon, Title } from '@mantine/core';
import React, { useMemo, useState } from 'react'
import SummaryCard from './Components/SummaryCard';
import { FaCalendarDay, FaCheck, FaCheckCircle, FaExclamationTriangle, FaSave, FaUser } from 'react-icons/fa';
import PageLayout from '../../PageLayout';
import { EButton, EPageTitle } from '../../libs/ui';
import { BsUpload } from 'react-icons/bs';
import useStudentWiseWorkingDays from './Hook/useStudentWiseWorkingDays';
import moment from 'moment';
import { EPlaceholder } from '../../libs/ui/src/Placeholder/EPlaceholder';

const StudentWiseWorkingDays = () => {
   const {
     classesBasedOnSchool,
     sectionBasedOnSchoolAndClass,
     attandanceDetails,
     setAttandanceDetails,
     getStudentDataApi,
     loading,
     students,
     setStudents,
     updatePresentDays,
     calculatedStudents,
     handleSaveAttendance,
     loadingSave,
     setIsUserChange,
     setCalculatedStudents,
     clearAll,
     setEditEnable,
     editEnable,
   } = useStudentWiseWorkingDays();
      // const TOTAL_WORKING_DAYS = 220;
      // const [saveStudentOpen,setSaveStudentOpen] = useState(true)
      // const [filters, setFilters] = useState({
      //   session: "2025-26",
      //   month: "July",
      //   class: "8A",
      //   subject: "Maths",
      // });
      // const [totalWorkingDays, setTotalWorkingDays] =  useState<any>(220)

      // const [students, setStudents] = useState<any[]>([
      //   { id: 1, srn: 2002, name: "Rahul", workingDays: 280, presentDays: 210 },
      //   { id: 2, srn: 2002, name: "Neha", workingDays: 280, presentDays: 198 },
      //   { id: 3, srn: 2002, name: "Aman", workingDays: 280, presentDays: 150 },
      //   { id: 4, srn: 2002, name: "Pooja", workingDays: 280, presentDays: 215 },
      // ]);

      /* ------------------ CALCULATIONS ------------------ */
      // const calculatedStudents = useMemo(() => {
      //   return students.map((s:any) => {
      //     const absent = attandanceDetails?.total_working_days - s.presentDays;
      //     const percentage = Number(
      //       ((s.presentDays / attandanceDetails?.total_working_days) * 100).toFixed(2),
      //     );

      //     return {
      //       ...s,
      //       absent,
      //       percentage,
      //     };
      //   });
      // }, [students]);
      // const calculatedStudents = useMemo(() => {
      //   const totalDays = Number(attandanceDetails?.total_working_days) || 0;

      //   return students.map((s: any) => {
      //     const presentDays = Number(s.presentDays) || 0;
      //     const clampedPresent = Math.min(presentDays, totalDays);

      //     const absent = totalDays - clampedPresent;

      //     const percentage =
      //       totalDays > 0 && clampedPresent > 0
      //         ? Number(((clampedPresent / totalDays) * 100).toFixed(2))
      //         : 0; // ✅ THIS fixes NaN%

      //     return {
      //       ...s,
      //       presentDays: clampedPresent,
      //       absent,
      //       percentage,
      //     };
      //   });
      // }, [students, attandanceDetails?.total_working_days]);

      // const averageAttendance = useMemo(() => {
      //   const total = calculatedStudents.reduce(
      //     (acc:any, s:any) => acc + s.percentage,
      //     0,
      //   );
      //   return Math.round(total / calculatedStudents.length);
      // }, [calculatedStudents]);

      // const below75Count = calculatedStudents.filter(
      //   (s:any) => s.percentage < 75,
      // ).length;

      /* ------------------ HANDLER ------------------ */
      // const updatePresentDays = (id: number, value: number | string) => {
      //   if (typeof value !== "number") return;

      //   setStudents((prev: any) =>
      //     prev.map((s: any) =>
      //       s.id === id
      //         ? { ...s, presentDays: Math.min(value, attandanceDetails?.total_working_days) }
      //         : s,
      //     ),
      //   );
      // };
  return (
    <PageLayout>
      <EPageTitle title="📘 Attendance Entry " />
      <Container size="lg">
        <Stack spacing="md">
          <div className="filter-container">
            <div className="flex justify-between gap-3">
              <div className="flex gap-5">
                <Select
                  required
                  clearable
                  searchable
                  label="Select Class"
                  placeholder="Select class"
                  data={classesBasedOnSchool.map((e) => ({
                    value: String(e?.id),
                    label: e?.name,
                  }))}
                  value={attandanceDetails?.class_id}
                  onChange={(v) => {
                    clearAll();
                    // setCalculatedStudents([]);
                    setAttandanceDetails((prev: any) => ({
                      ...prev,
                      class_id: v,
                    }));
                  }}
                />

                <Select
                  required
                  clearable
                  searchable
                  disabled={!attandanceDetails?.class_id}
                  label=" Select Section"
                  placeholder="Select Section"
                  data={sectionBasedOnSchoolAndClass.map((e) => ({
                    value: String(e?.id),
                    label: e?.name,
                  }))}
                  value={attandanceDetails?.section_id}
                  onChange={(v) => {
                    clearAll();
                    // setCalculatedStudents([]);
                    setAttandanceDetails((prev: any) => ({
                      ...prev,
                      section_id: v,
                    }));
                  }}
                />

                {/* <Select
                  required
                  clearable
                  searchable
                  label="Select Year"
                  placeholder="Select Year"
                   data={["2025", "2026"]}
                  value={attandanceDetails?.year}
                  onChange={(v) => {
                    clearAll();
                    // setCalculatedStudents([]);
                    setAttandanceDetails((prev: any) => ({
                      ...prev,
                      year: v,
                    }));
                  }}
                />

                <Select
                  required
                  clearable
                  searchable
                  label="Select Month"
                  placeholder="Select month"
                  data={[
                    { value: "01", label: "January" },
                    { value: "02", label: "February" },
                    { value: "03", label: "March" },
                    { value: "04", label: "April" },
                    { value: "05", label: "May" },
                    { value: "06", label: "June" },
                    { value: "07", label: "July" },
                    { value: "08", label: "August" },
                    { value: "09", label: "September" },
                    { value: "10", label: "October" },
                    { value: "11", label: "November" },
                    { value: "12", label: "December" },
                  ]}
                  value={attandanceDetails?.month}
                  onChange={(v) => {
                    clearAll();
                    // setCalculatedStudents([]);
                    setAttandanceDetails((prev: any) => ({
                      ...prev,
                      month: v,
                    }));
                  }}
                /> */}
                <Select
                  required
                  clearable
                  searchable
                  label="Select Session"
                  placeholder="Select Session"
                  data={[
                    // { label: "2024-2025", value: "2025" },
                    { label: "2025-2026", value: "2026" },
                    { label: "2026-2027", value: "2027" },
                  ]}
                  value={attandanceDetails?.year}
                  onChange={(v) => {
                    clearAll();
                    setAttandanceDetails((prev: any) => ({
                      ...prev,
                      year: v,
                    }));
                  }}
                />

                {/* <Select
                  label="Select month"
                  placeholder="Select month"
                  data={[
                    {
                      label: "April",
                      value: "04",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 4
                          ? true
                          : false,
                    },
                    {
                      label: "May",
                      value: "05",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 5
                          ? true
                          : false,
                    },
                    {
                      label: "June",
                      value: "06",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 6
                          ? true
                          : false,
                    },
                    {
                      label: "July",
                      value: "07",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 7
                          ? true
                          : false,
                    },
                    {
                      label: "August",
                      value: "08",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 8
                          ? true
                          : false,
                    },
                    {
                      label: "September",
                      value: "09",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 9
                          ? true
                          : false,
                    },
                    {
                      label: "October",
                      value: "10",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 10
                          ? true
                          : false,
                    },
                    {
                      label: "November",
                      value: "11",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 11
                          ? true
                          : false,
                    },
                    {
                      label: "December",
                      value: "12",
                      disabled:
                        attandanceDetails?.year ==
                          moment().add(1, "year").format("YYYY") &&
                        parseInt(moment().format("MM"), 10) < 12
                          ? true
                          : false,
                    },
                    {
                      label: "January",
                      value: "01",
                      disabled:
                        attandanceDetails?.year ==
                        moment().add(1, "year").format("YYYY")
                          ? true
                          : false,
                    },
                    {
                      label: "February",
                      value: "02",
                      disabled:
                        attandanceDetails?.year ==
                        moment().add(1, "year").format("YYYY")
                          ? true
                          : false,
                    },
                    {
                      label: "March",
                      value: "03",
                      disabled:
                        attandanceDetails?.year ==
                        moment().add(1, "year").format("YYYY")
                          ? true
                          : false,
                    },
                  ]}
                  value={attandanceDetails?.month}
                  onChange={(v) => {
                    clearAll();
                    setAttandanceDetails((prev: any) => ({
                      ...prev,
                      month: v,
                    }));
                  }}
                /> */}
              </div>
              <div className="flex gap-3 items-end">
                <EButton
                  loading={loading}
                  onClick={() => {
                    clearAll();
                    getStudentDataApi();
                  }}
                  className="btn-blue"
                  disabled={
                    !attandanceDetails?.class_id ||
                    !attandanceDetails?.section_id ||
                    !attandanceDetails?.year ||
                    !attandanceDetails?.month
                  }
                >
                  Search
                </EButton>
              </div>
            </div>
          </div>
          {loading ? (
            <>
              <Skeleton height={50} radius="xl" mb="xl" />
              <Skeleton height={8} radius="xl" />
              <Skeleton height={8} mt={6} radius="xl" />
              <Skeleton height={8} mt={6} width="70%" radius="xl" />
            </>
          ) : (
            <>
              {calculatedStudents?.length > 0 ? (
                <>
                  <div className="flex gap-3">
                    <div className="w-1/5">
                      <NumberInput
                        disabled={!editEnable}
                        required
                        description="Total Working Days in Selected Session"
                        label="Total Working Days (School)"
                        value={attandanceDetails?.total_working_days}
                        min={0}
                        max={365}
                        hideControls
                        parser={(value) => value?.replace(/\D/g, "") ?? ""}
                        onChange={(v) => {
                          setIsUserChange(true);
                          const totalDays = typeof v === "number" ? v : 0;

                          // update attendance details
                          setAttandanceDetails((prev: any) => ({
                            ...(prev ?? {}),
                            total_working_days: totalDays,
                          }));

                          // 🔥 reset absent for all students
                          // setStudents((prev: any[]) =>
                          //   prev.map((s: any) => {
                          //     return {
                          //       ...s,
                          //       presentDays:0,
                          //       absent: 0,
                          //     };
                          //   }),
                          // );
                        }}
                        // onChange={
                        //   (v) =>
                        //     setAttandanceDetails((prev: any) => ({
                        //       ...prev,
                        //       total_working_days: typeof v === "number" ? v : 0,
                        //     }))
                        //   // setTotalWorkingDays(typeof v === "number" ? v : 0)
                        // }
                      />
                    </div>
                  </div>

                  <Divider />

                  {/* TABLE */}
                  <Card withBorder radius="md">
                    <Table striped highlightOnHover>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>SRN No.</th>
                          <th>Student Name</th>
                          <th>Present Days</th>
                          <th>Absent</th>
                          <th>Attendance %</th>
                        </tr>
                      </thead>

                      <tbody>
                        {calculatedStudents?.map((s: any, index: any) => (
                          <tr
                            key={s.id}
                            style={{
                              backgroundColor:
                                s.percentage < 75 ? "#fff9db" : undefined,
                            }}
                          >
                            <td>{index + 1}</td>
                            <td>{s.studentRegistrationNumber}</td>
                            <td>{s.studentName}</td>

                            <td style={{ maxWidth: 120 }}>
                              <NumberInput
                                disabled={
                                  !attandanceDetails?.total_working_days ||
                                  !editEnable
                                }
                                value={s.presentDays}
                                min={0}
                                max={attandanceDetails?.total_working_days}
                                hideControls
                                parser={(value) =>
                                  value?.replace(/\D/g, "") ?? ""
                                }
                                onChange={(v) =>
                                  updatePresentDays(
                                    s.studentRegistrationNumber,
                                    typeof v === "number" ? v : 0,
                                  )
                                }
                              />
                            </td>

                            <td>{s.absent}</td>

                            <td>
                              <Badge
                                variant="light"
                                color={
                                  s.percentage >= 75
                                    ? "green"
                                    : s.percentage >= 60
                                      ? "yellow"
                                      : "red"
                                }
                              >
                                {s.percentage}%
                              </Badge>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card>

                  {/* ACTION BAR */}
                  <Group position="right">
                    <EButton
                      disabled={editEnable}
                      className="btn-blue"
                      leftIcon={<FaSave size={18} />}
                      color="blue"
                      onClick={() => setEditEnable(true)}
                    >
                      Edit Attendance
                    </EButton>
                    <EButton
                      disabled={!editEnable}
                      className="btn-blue"
                      leftIcon={<FaSave size={18} />}
                      color="blue"
                      onClick={handleSaveAttendance}
                      loading={loadingSave}
                    >
                      Save Attendance
                    </EButton>
                  </Group>
                </>
              ) : (
                <>
                  <EPlaceholder
                    iconSrc={
                      require("../../assets/icons/icon-placeholder.svg").default
                    }
                    title="No Students Found"
                    description="No records match your selected filters."
                  />
                </>
              )}
            </>
          )}
        </Stack>
      </Container>
    </PageLayout>
  );
}

export default StudentWiseWorkingDays